import ActionButton from "@/components/Button/ActionButton";
import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { genNameInitials } from "@/utils/name";
import type { SelectedPersonOption } from "../../-types";

const InviteComboboxSelectedPersonOptionChip = (props: {
  option: SelectedPersonOption;
  onSelect: (value: string) => void;
  disabled?: boolean;
}) => {
  const { option, onSelect, disabled = false } = props;

  return (
    <div className="flex items-center gap-1 rounded-[var(--radius-rounded-md)] border border-neutral-border py-0.5 pl-2.5 pr-2">
      <HStack className="items-center gap-1.5">
        <Avatar className="size-9">
          <AvatarImage src={option.avatarUrl} alt={option.label} />
          <AvatarFallback>
            <Text variant="labelSmall">{genNameInitials(option.label)}</Text>
          </AvatarFallback>
        </Avatar>
        <VStack>
          <Text variant="labelSmall">{option.label}</Text>
        </VStack>
      </HStack>
      <ActionButton
        onClick={() => onSelect(option.id)}
        icon="XIcon"
        iconColor="active"
        variant="ghost"
        className="size-fit p-0"
        disabled={disabled}
      />
    </div>
  );
};

export default InviteComboboxSelectedPersonOptionChip;
